export default function logger({ functionName, error, sentry }) {
  if (process.env.NODE_ENV === "development") {
    // console.log(error);
  } else if (sentry) {
    fetch("/sentry/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message: `Referral Engine::FE::error::${functionName}::: ${JSON.stringify(
          error
        )} : ${JSON.stringify(error.message)} : ${JSON.stringify(error.stack)}`,
      }),
    });
  }
}
